import { ManagedUserRolesArray } from "@redotech/account-common/roles";
import { USER_ROLES } from "@redotech/redo-model/user";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

const teamUserSchema = z.object({
  _id: zExt.objectId(),
  name: z.string(),
  email: z.string(),
  legacyRoles: zExt.filterToValidArray(createEnum(USER_ROLES)).nullish(),
  userRoles: z.array(zExt.objectId()),
  managedUserRoles: zExt.filterToValidArray(createEnum(ManagedUserRolesArray)),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export type TeamUser = z.infer<typeof teamUserSchema>;

export const getTeamUsers = {
  name: "getTeamUsers" as const,
  input: z.null(),
  output: z.object({ users: z.array(teamUserSchema) }),
};
